import { TreeItem } from "./types";

export const filterTreeViewItems = (
  criteria: string,
  treeViewItem: TreeItem
): TreeItem | null => {
  const normalizedLabel = treeViewItem.label.trim().toLowerCase();

  if (normalizedLabel.includes(criteria)) {
    return treeViewItem;
  }

  const filteredChildren: TreeItem[] =
    treeViewItem.children
      ?.map((child) => filterTreeViewItems(criteria, child))
      .filter((child) => child !== null) || [];

  return filteredChildren.length > 0
    ? { ...treeViewItem, children: filteredChildren }
    : null;
};

export const getItemsIds = (
  treeViewItems: TreeItem[] | undefined
): string[] => {
  if (!treeViewItems) {
    return [];
  }

  return treeViewItems.flatMap((item) => [
    item.id,
    ...(item.children ? getItemsIds(item.children) : []),
  ]);
};
